import { Component, OnInit,  ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { ActivatedRoute, Router, ActivatedRouteSnapshot, RouteReuseStrategy, NavigationEnd, Event as NavigationEvent } from '@angular/router';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { Subscription } from 'rxjs';
import { HaloLoaderService } from '../../../core/halo-loader/halo-loader.service';
import { MemberFirebaseTokenService, IToken } from '../../services/member-firebase-token.service';
import {tab, TRAININGDATA } from '../training-data';
import { environment } from '../../../../environments/environment';
import { SafeUrl } from '@angular/platform-browser';
import { CommonUtil } from '../../../core/Utils/common-util';
import { BreadcrumbService } from '../../services/breadcrumb.service';



@Component({
  selector: 'app-training-classes',
  templateUrl: './training-classes.component.html',
  styleUrls: ['./training-classes.component.scss']
})
export class TrainingClassesComponent implements OnInit {

  // subscriptions
  private _facilityOnChange: Subscription;
  private _consoleOnChange: Subscription;
  private _tabOnChange: Subscription;

  rootScopeData: RootScopeDeclare;
  currentFacility: FacilityObject;
  memberToken: string;
  membrBasePath: string;
  trainingSubPath: SafeUrl|null = '';
  currentPath:string = 'dashboard';
  currentTabDetails:tab[] =[{page:'', key:'', url:''}];
  classesTabs:string[] = ['schedule', 'locations', 'classtypes'];
  breadCrumbData = ['HOME','TRAINING.CLASSES','CLASSES','CLASSES.SCHEDULE'];
  showIframeLoader:boolean = true;

  constructor(private rootScopeService: RootScopeService,
    private _breadcrumbService: BreadcrumbService, 
    private _facilityService: FacilityService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _getMemberToken: MemberFirebaseTokenService,
    private loader: HaloLoaderService,
    private _commonUtil: CommonUtil) { }

  ngOnInit(): void {
    this.getRootScopeData();
    this.membrBasePath = environment.membrHostPath; 

    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.currentFacility = res;
      this.fetchTrainingData();
    });

    let path = this._router.url.split("/");
    this.currentPath = path[path.length-1];    
    this.setTabDetails(this.currentPath);

    this._tabOnChange = this._router.events.subscribe(
      (event: NavigationEvent): void => {
        if (event instanceof NavigationEnd) {
          let path = this._router.url.split("/");
          this.currentPath = path[path.length-1];         
          this.setTabDetails(this.currentPath);
          this.fetchTrainingData();  
        }
      }
    );

    this.fetchTrainingData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => {
      this.rootScopeData = rootScopeData;
    });
  }

  setTabDetails(name: string): void {
    if(this.classesTabs.indexOf(name)> -1){
      this.rootScopeData.pageName = 'TrainingClasses - classes';
    }else{
      this.rootScopeData.pageName = 'TrainingClasses - ' + name;
    }
    this.currentTabDetails = TRAININGDATA.filter(u => 
      u.page == name);
  }

  goToTab(name:string){
    this.currentPath = name;
    this.setTabDetails(this.currentPath);
    this.fetchTrainingData();  
    if(name === 'schedule'){
      this.breadCrumbData[3] = 'CLASSES.SCHEDULE';
    }else if(name === 'locations'){
      this.breadCrumbData[3] = 'LOCATIONS';
    }else{
      this.breadCrumbData[3] = 'CLASSES.CLASSTYPES';
    }
    this._breadcrumbService.set(this.breadCrumbData);
  }

  ngOnDestroy() {
    // $('#atlwdg-trigger').css('display', "none");
    // destroy subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
    this._tabOnChange.unsubscribe();
  }

  fetchTrainingData(){
    if ((this.currentFacility.summary && this.currentFacility.summary.facilityRights.trainingMenu != 'true') ||
    (this.currentFacility.summary && this.currentFacility.summary.facilityRights.trainingClasses == 'false' && this.classesTabs.indexOf(this.currentPath)> -1) ||
    (this.currentFacility.summary && this.currentFacility.summary.facilityRights.trainingPrograms == 'false' && (this.currentPath.indexOf('dashboard')>-1 || this.currentPath.indexOf('training')>-1))) {
      this._commonUtil.redirectToAvailablePage();
    }
    this.getToken();
  }

  getToken(){    
    this.loader.startProcess();
      this._getMemberToken
        .get()
        .subscribe(
          (data: IToken) => {
            this.loader.endProcess();
            this.memberToken=data.jwtToken;
            if(this.trainingSubPath && this.trainingSubPath.toString().indexOf('<facId>')>-1)
              this.trainingSubPath=this.trainingSubPath.toString().replace('<facId>',this.currentFacility.facilityId);
            else
              this.trainingSubPath = this.membrBasePath + this.memberToken + this.currentTabDetails[0].url+"&facilityId="+this.currentFacility.facilityId+"&locale="+this.rootScopeData.currentUser.preferredLanguage;
            
          },
          error => {
            console.error('API failed.');
            this.loader.endProcess();
          }
        );
  }

  showLoadSpinner(){
    this.showIframeLoader =true;
  }

  hideLoadSpinner(){
    this.showIframeLoader =false;
  }
}
